<script>
import { isVisibleOnWeb } from "%/dynamic-component-editor/helpers/visibility-surface";
import resolveVisibleOption from "%/dynamic-component-editor/helpers/resolve-visible-option";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import {
  BaseStoryCardElementMixin,
} from "%/dynamic-component-editor/standard-components/base-story-card/base-story-card-element-mixin";
import StoryCardClickBehavior from "%/dynamic-component-editor/options/story-card-click-behavior";
import UrlElement from "%/dynamic-component-editor/standard-elements/url-element/UrlElement.vue";

export default {
  name: "ExclusiveBadge",
  elementPanelSettings: {
    displayName: "Exclusive Badge",
    displayIcon: "box",
    elementType: "element",
    elementGroup: "storyElements",
  },
  dropsAsElementType: "DynamicComponentElement",
  extends: UrlElement,
  mixins: [BaseStoryCardElementMixin],
  options: [BackgroundColor, StoryCardClickBehavior],
  computed: {
    label() {
      return "Exclusive";
    },
    computedHref() {
      return this.storyHref;
    },
    isBoundStoryExclusive() {
      const story = this.entity;
      return Boolean(story?.exclusive ?? story?.isExclusive);
    },
    // Non-exclusive story never shows the badge (edit/preview stay visible so it's
    // designable); else mirrors appearance-mixin myVisibility.
    myVisibility() {
      if (!this.editMode && !this.isPreviewMode && !this.isBoundStoryExclusive) {
        return false;
      }
      if (this.eventVisibilityOverride !== null && this.eventVisibilityOverride !== undefined) {
        return this.eventVisibilityOverride;
      }
      // XXX: isVisibleOnWeb, NOT Boolean() -- "mobile-only" is truthy.
      return isVisibleOnWeb(resolveVisibleOption(this.getOptionValue(`${this.activeState}.visible`), this));
    },
  },
};
</script>

<style scoped lang="scss">
</style>
